import { useGetRelationsOutByIdQuery } from "../../../services/objects"
import { ListPanelWrapper } from "../../components/ListPaneWrapper"
import { IBaseCounter } from "./types"


export const RelatedPlantsSmall = (props: IBaseCounter) => {
    const { data, isLoading, isSuccess, error, refetch } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: 'Measures' })


    return (
        <>
                {data && data.map((target) =>
                    <><ListPanelWrapper small {...target}></ListPanelWrapper></>)
                }
              
        </>
    )
}